import { Route, Routes } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./features/home/Home";
import ErrorMissing from './components/ErrorMissing'
import PersistLogin from "./features/auth/PersistLogin";
import RequireAuth from './features/auth/RequireAuth';
import Effectifs from "./features/effectifs/Effectifs";
import Presence from "./features/presence/Presence";
import Recap from "./features/recap/Recap";
import { ToastContainer } from 'react-toastify';
import { useHasRole } from "./hooks/useHasRole";
import { ROLES } from "./context/dataApplicationsContext";
import GeneralVue from "./features/presence/GeneralVue";
import PolitiqueConfidentialite from "./components/Politiqueconfidentialite";
import RequireAdmin from "./features/auth/RequireAdmin";
import SettingsIndex from "./features/settings/SettingsIndex";


function App() {
  const isAdmin = useHasRole(ROLES.ADMIN);

  return (
    <>
      <ToastContainer
        position="top-right" autoClose={4000} hideProgressBar={false} newestOnTop={false} closeOnClick
        rtl={false} draggable pauseOnHover className={'z-10001'}
      />
      <Routes>
        <Route element={<PersistLogin />}>
          <Route path='/confidentialite' element={<PolitiqueConfidentialite />} />
          <Route path='/' element={<Layout />}>
            <Route index element={<Home />} />
            <Route element={<RequireAuth />}>
              <Route path='/effectifs' element={<Effectifs isAdmin={isAdmin}/>} />
              <Route path='/presence' element={<Presence />} />
              <Route path='/generale-presence' element={<GeneralVue />} />

              <Route element={<RequireAdmin />}>
                <Route path='/recap' element={<Recap />} />
                <Route path='/settings' element={<SettingsIndex />} />
              </Route>
            </Route>
            <Route path='*' element={<ErrorMissing />} />
          </Route>
        </Route>
      </Routes>
    </>
  );
}

export default App;
